import { useRouter } from "@tanstack/react-router";
import { useEffect } from "react";
import { toast } from "sonner";
import { useAuth } from "@/components/providers/auth";
import { isStaffConsoleEnabled } from "@/lib/modules";

export const STAFF_ROLE_FULL = "Staff";
export const STAFF_ROLE_READ_ONLY = "StaffReadOnly";

/**
 * Client-side gate for the staff console. The backend enforces the module flag
 * and staff roles on every /api/admin endpoint; this only handles UX
 * (redirect non-staff or module-disabled visits to /403).
 */
export function useStaffGuard() {
	const { user, isInitialLoading } = useAuth();
	const router = useRouter();

	const moduleEnabled = isStaffConsoleEnabled();
	const isStaff = moduleEnabled && !!user?.staffRole;
	const isFullStaff = isStaff && user?.staffRole === STAFF_ROLE_FULL;

	useEffect(() => {
		if (!moduleEnabled) {
			router.navigate({ to: "/403" });
			return;
		}
		if (!isInitialLoading && user && !user.staffRole) {
			toast.warning("Staff access required", {
				description: "You do not have permission to view the admin console.",
			});
			router.navigate({ to: "/403" });
		}
	}, [moduleEnabled, isInitialLoading, user, router]);

	return { isStaff, isFullStaff, isLoading: isInitialLoading };
}
